// 立即建立連線（不等 DOM ready），確保 window.ably 在其他腳本載入時已可用
// 使用 Token Auth（authCallback）：後端呼叫 Ably requestToken 拿 TokenDetails 回傳，
// 前端以 localStorage 快取，24 小時 TTL 內跨頁共用，提前 60 秒強制 refresh。
// 快取以 clientId 比對，確保切換帳號時自動廢棄舊 token。
window.ably = new Ably.Realtime({
    authCallback: function (tokenParams, callback) {
        var CACHE_KEY = 'wtoy_ably_token';
        var currentUserId = WTOY_ABLY_SETTING.currentUserId || null;

        try {
            var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
            if (
                cached &&
                cached.token &&
                cached.expires &&
                cached.expires > Date.now() + 60000 &&
                (cached.clientId || null) === currentUserId
            ) {
                return callback(null, cached);
            }
        } catch (e) { /* 壞 JSON，fallthrough 重新取 */ }

        var authUrl = WTOY_ABLY_SETTING.authUrl + '?expected_user_id=' + encodeURIComponent(currentUserId || '');
        var authHeaders = WTOY_ABLY_SETTING.nonce ? { 'X-WP-Nonce': WTOY_ABLY_SETTING.nonce } : {};

        fetch(authUrl, { credentials: 'same-origin', headers: authHeaders })
            .then(function (r) { return r.json(); })
            .then(function (tokenDetails) {
                // 錯誤回應（401 的 WP 標準錯誤格式、429 的 body 為 null、503 的
                // { message }）都沒有 token 欄位——不得當成 token 交給 SDK，也不得寫進快取
                if (!tokenDetails || !tokenDetails.token) {
                    return callback(new Error('ably token unavailable'), null);
                }
                try { localStorage.setItem(CACHE_KEY, JSON.stringify(tokenDetails)); } catch (e) {}
                callback(null, tokenDetails);
            })
            .catch(function (err) { callback(err, null); });
    },
});

window.ably.connection.on('connected', function () {
    console.log('Connected to Ably!');
});

window.ably.connection.on('close', function () {
    console.log('Ably connection closed.');
});

// global 頻道：跑馬燈（需等 DOM ready 才呼叫 startMarquee）
jQuery(function($) {
    var channel = window.ably.channels.get('global');
    var marquee = [];
    channel.subscribe('marquee', function(message) {
        marquee.push(message.data.text);
        console.log(marquee);
        window.startMarquee(marquee);
    });
});
